/**
 * Casa Mirari — <cm-outfits> stacked card carousel.
 * Drag / swipe the front card (left = next, right = previous), use the ‹ › buttons,
 * or the ← → keys. A tap on the front card opens the outfit; a drag never counts as a tap.
 */
(function () {
  'use strict';
  if (customElements.get('cm-outfits')) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var OUT_MS = reduceMotion ? 0 : 420;

  class CmOutfits extends HTMLElement {
    connectedCallback() {
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-card]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-panel]'));
      this.stack = this.querySelector('[data-stack]');
      this.index = 0;
      this.busy = false;
      if (this.cards.length < 2) return;

      this.querySelector('[data-next]').addEventListener('click', () => this.go(1));
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(-1));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
      });

      this.cards.forEach((card) => {
        card.addEventListener('dragstart', (e) => e.preventDefault());
        card.addEventListener('click', (e) => {
          if (this.suppressClick) { e.preventDefault(); e.stopPropagation(); this.suppressClick = false; }
        }, true);
      });

      this.stack.addEventListener('pointerdown', (e) => this.onDown(e));
      this.stack.addEventListener('pointermove', (e) => this.onMove(e));
      this.stack.addEventListener('pointerup', (e) => this.onUp(e));
      this.stack.addEventListener('pointercancel', (e) => this.onUp(e, true));
      this.render();
    }

    front() { return this.cards[this.index]; }

    render() {
      var n = this.cards.length;
      this.cards.forEach((card, i) => {
        var pos = (i - this.index + n) % n;
        card.dataset.pos = pos < 3 ? String(pos) : 'rest';
        var isFront = pos === 0;
        card.setAttribute('aria-hidden', isFront ? 'false' : 'true');
        if (isFront) card.removeAttribute('tabindex'); else card.setAttribute('tabindex', '-1');
        if (pos < 3) {
          var img = card.querySelector('img[loading="lazy"]');
          if (img) img.loading = 'eager';
        }
      });
      this.panels.forEach((p, i) => { p.hidden = i !== this.index; });
    }

    go(dir, flyFrom) {
      if (this.busy) return;
      var n = this.cards.length;
      var leaving = this.front();
      this.busy = true;
      if (dir > 0) {
        // front card flies out to the left (or the drag direction), then drops to the back
        leaving.style.transform = '';
        leaving.classList.remove('is-dragging');
        leaving.classList.add(flyFrom === 'right' ? 'is-out-right' : 'is-out-left');
        setTimeout(() => {
          leaving.classList.add('no-anim');
          leaving.classList.remove('is-out-left', 'is-out-right');
          this.index = (this.index + 1) % n;
          this.render();
          void leaving.offsetWidth;
          leaving.classList.remove('no-anim');
          this.busy = false;
        }, OUT_MS);
      } else {
        // previous card enters from the left on top of the stack
        var prevIndex = (this.index - 1 + n) % n;
        var entering = this.cards[prevIndex];
        if (flyFrom === 'right' || flyFrom === 'left') {
          leaving.style.transform = '';
          leaving.classList.remove('is-dragging');
        }
        entering.classList.add('no-anim', 'is-out-left');
        entering.dataset.pos = '0';
        void entering.offsetWidth;
        entering.classList.remove('no-anim');
        this.index = prevIndex;
        requestAnimationFrame(() => {
          entering.classList.remove('is-out-left');
          this.render();
          setTimeout(() => { this.busy = false; }, OUT_MS);
        });
      }
    }

    onDown(e) {
      if (this.busy || e.button > 0) return;
      var card = e.target.closest('[data-card]');
      if (!card || card !== this.front()) return;
      this.drag = { card: card, x: e.clientX, y: e.clientY, dx: 0, t: performance.now(), id: e.pointerId, active: false };
    }

    onMove(e) {
      var d = this.drag;
      if (!d || e.pointerId !== d.id) return;
      d.dx = e.clientX - d.x;
      var dy = e.clientY - d.y;
      if (!d.active) {
        if (Math.abs(d.dx) < 6) return;
        if (Math.abs(dy) > Math.abs(d.dx)) { this.drag = null; return; } // vertical scroll wins
        d.active = true;
        d.card.classList.add('is-dragging');
        try { this.stack.setPointerCapture(d.id); } catch (err) { /* ignore */ }
      }
      e.preventDefault();
      d.card.style.transform = 'translateX(' + d.dx + 'px) rotate(' + (d.dx / 24) + 'deg)';
    }

    onUp(e, cancelled) {
      var d = this.drag;
      this.drag = null;
      if (!d || !d.active) return;
      this.suppressClick = true;
      setTimeout(() => { this.suppressClick = false; }, 60);
      var width = this.stack.offsetWidth || 1;
      var velocity = Math.abs(d.dx) / Math.max(1, performance.now() - d.t);
      var passed = !cancelled && (Math.abs(d.dx) > width * 0.25 || velocity > 0.6);
      d.card.classList.remove('is-dragging');
      if (!passed) { d.card.style.transform = ''; return; }
      if (d.dx < 0) this.go(1, 'left');
      else this.go(-1, 'right');
    }
  }

  customElements.define('cm-outfits', CmOutfits);
})();
